import React from 'react'

import { StateObjMultiple } from '../../../../src/utils/stateObj.js'
import { widgetEnum } from '../../../../utils/constants.js'
import { FLIGHT_DETAILS_ID_DESKTOP, FLIGHT_DETAILS_ID_MOBILE } from '../constants.js'

import { FlightDetailsView } from './flightDetailsView.js'

export function create (app, config) {
  const defaultState = {
    flightInfo: null,
    flightId: null,
    loadingFlightInfo: false
  }

  const widgetState = new StateObjMultiple({
    ...defaultState
  })

  const { Loading } = app.themePack

  const log = app.log.sublog('flightDetails')

  app.bus.send('layers/register', {
    id: FLIGHT_DETAILS_ID_DESKTOP,
    widget: () => <FlightDetailsView
      T={app.gt()}
      widgetState={widgetState}
      onCloseClicked={onCloseClicked}
      onGetDirectionClick={onGetDirectionClick}
      isDesktop={() => app.env.isDesktop()}
      bus={app.bus}
      Loading={Loading}
    />,
    layoutId: 'content',
    layoutName: 'fullscreen',
    widgetType: widgetEnum.Desktop
  })

  app.bus.send('layers/register', {
    id: FLIGHT_DETAILS_ID_MOBILE,
    widget: () => <FlightDetailsView
      T={app.gt()}
      widgetState={widgetState}
      onCloseClicked={onCloseClicked}
      onGetDirectionClick={onGetDirectionClick}
      isDesktop={() => app.env.isDesktop()}
      bus={app.bus}
      Loading={Loading}
      id={FLIGHT_DETAILS_ID_MOBILE}
    />,
    layoutId: 'bottomBar',
    layoutName: 'fullscreen',
    widgetType: widgetEnum.Mobile
  })

  const onCloseClicked = () => {
    app.bus.send('history/stepBack')

    app.bus.send('layers/hideMultiple', [FLIGHT_DETAILS_ID_DESKTOP, FLIGHT_DETAILS_ID_MOBILE])
    app.bus.send('map/cleanMap')
    widgetState.update({ ...defaultState })
  }

  const onGetDirectionClick = () => {
    const { flightInfo } = widgetState.getState()

    app.bus.send('layers/hideMultiple', [FLIGHT_DETAILS_ID_DESKTOP, FLIGHT_DETAILS_ID_MOBILE])
    app.bus.send('navigation/searchDirectionsToId', { poiId: flightInfo.gate.poiId, referrer: 'entityView' })
  }

  const showFlight = async flightId => {
    widgetState.update({ ...defaultState, loadingFlightInfo: true })

    app.bus.send('layers/hideWithLayoutId', 'headerOnline')

    if (!app.env.isDesktop()) app.bus.send('layers/hideWithLayoutId', 'content')

    app.bus.send('layers/show', { id: FLIGHT_DETAILS_ID_DESKTOP })
    app.bus.send('layers/show', { id: FLIGHT_DETAILS_ID_MOBILE })

    try {
      const flight = await app.bus.get('flightStatus/getFlight', { flightId })
      const flightInfo = await app.bus.get('flightStatus/mapFlightDetails', { flight })
      widgetState.update({ flightId, flightInfo })

      const { gatePoi } = flight
      if (gatePoi) {
        app.bus.send('map/selectEntities', { ids: [gatePoi.poiId] })
        const { latitude, longitude, floorId } = gatePoi.position
        app.bus.send('map/animateToPointWithRadius', { lat: latitude, lng: longitude, floorId, radius: gatePoi.zoomRadius })
      }
    } catch (e) {
      log.error(e)
    }

    app.bus.send('layers/show', { id: FLIGHT_DETAILS_ID_DESKTOP })
    app.bus.send('layers/show', { id: FLIGHT_DETAILS_ID_MOBILE })

    app.bus.send('history/register', { viewId: FLIGHT_DETAILS_ID_DESKTOP, event: 'flightDetails/show', params: { flightId } })
    app.bus.send('history/register', { viewId: FLIGHT_DETAILS_ID_MOBILE, event: 'flightDetails/show', params: { flightId } })
    widgetState.update({ loadingFlightInfo: false })
  }

  app.bus.on('flightDetails/show', ({ flightId }) => showFlight(flightId))

  const runTest = async (initialState, testRoutine) => {
    widgetState.update({ ...initialState })
    await testRoutine()
    return widgetState.getState()
  }

  return {
    init: () => { },
    runTest
  }
}
